import { render, staticRenderFns } from "./NewSession.vue?vue&type=template&id=562873a0&"
import script from "./NewSession.vue?vue&type=script&lang=js&"
export * from "./NewSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports